import ToggleButton from '@cartwhl/ui/input/ToggleButton';

import type { BoneAssignmentMode } from '../types';

type BoneAssignmentModeToggleOrientation = 'horizontal' | 'vertical';

interface BoneAssignmentModeToggleProps {
  mode: BoneAssignmentMode;
  onModeChange: (mode: BoneAssignmentMode) => void;
  orientation?: BoneAssignmentModeToggleOrientation;
  className?: string;
  buttonClassName?: string;
}

export default function BoneAssignmentModeToggle({
  mode,
  onModeChange,
  orientation = 'horizontal',
  className,
  buttonClassName,
}: BoneAssignmentModeToggleProps) {
  const stopPropagation = (event: { stopPropagation: () => void }) => {
    event.stopPropagation();
  };
  const layoutClassName =
    orientation === 'vertical' ? 'flex flex-col gap-1' : 'flex items-center gap-1';
  const resolvedButtonClassName =
    buttonClassName ?? '!h-[21px] min-w-[96px] justify-center px-3';

  return (
    <div className="flex justify-center" onClick={stopPropagation}>
      <div className={`${layoutClassName} ${className ?? ''}`.trim()}>
        <ToggleButton
          active={mode === 'roles'}
          aria-label="Show roles assignment mode"
          aria-pressed={mode === 'roles'}
          onClick={() => onModeChange('roles')}
          text="Roles"
          className={resolvedButtonClassName}
        />
        <ToggleButton
          active={mode === 'chains'}
          aria-label="Show chains assignment mode"
          aria-pressed={mode === 'chains'}
          onClick={() => onModeChange('chains')}
          text="Chains"
          className={resolvedButtonClassName}
        />
      </div>
    </div>
  );
}
